<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    class="w-[80%] max-w-[370px]"
  >
    <div class="flex flex-col items-center py-10 px-4 gap-6">
      <h2 class="text-2xl">
        {{ $t("purchase.crystal.confirm") }}
      </h2>
      <div class="w-full flex justify-between">
        <p>{{ $t("purchase.power.current") }}</p>
        <p class="text-primary" @click="clickBuyMore">
          {{ $t("purchase.crystal.buyMore") }}
        </p>
      </div>

      <div class="flex items-center w-full">
        <div class="bg-neutral rounded-full p-2 relative z-10">
          <img :src="usePowerUrl()" alt="" class="w-[14px] mt-0.5" />
        </div>
        <div
          class="bg-neutral rounded-r-2xl flex-1 -ml-2 relative z-0 text-center"
        >
          {{ userStore.user.powerAmount || 0 }}
        </div>
      </div>

      <div v-if="showAmount" class="w-full">
        {{ $t(`purchase.crystal.amount`) }}
        <div class="flex justify-between items-center gap-4 mt-4 w-full">
          <div>1</div>
          <VanSlider v-model="reqData.amount" :min="1" :max="12" size="sm">
            <template #button>
              <button class="btn btn-circle btn-xs">
                {{ reqData.amount }}
              </button>
            </template>
          </VanSlider>
          <div>12</div>
        </div>
      </div>
      <!-- <van-checkbox v-model="reqData.isAddNSFWTag">
        {{ $t("purchase.crystal.autoAddTag") }}
      </van-checkbox> -->

      <div>
        <button
          v-if="isPowerCubeNotEnough"
          class="btn btn-primary flex gap-0 items-center mb-3.5 w-full"
          @click="clickSwapAndGenerate"
        >
          <b>{{ $t(`Buttons.exchange`) + "&" + $t(`Buttons.generate`) }}</b>
          <span class="text-xs font-normal ml-2.5 mr-0.5">
            {{ $t(`purchase.crystal.cost`) }}
            {{ shouldByCrystalAmount }}
          </span>
          <img :src="useCrystalUrl()" alt="" class="w-3" />
        </button>
        <button
          class="btn btn-primary flex gap-0 items-center mt-6 mb-3.5 w-full"
          @click="emit('generate')"
          :disabled="isPowerCubeNotEnough"
        >
          <b>{{ $t(`Buttons.generate`) }}</b>
          <span class="text-xs font-normal ml-2.5 mr-0.5">
            {{ $t(`purchase.crystal.cost`) }}
            {{ (reqData.amount || 1) * 2 }}
          </span>
          <img :src="usePowerUrl()" alt="" class="w-3" />
        </button>

        <button
          class="btn btn-primary w-full"
          @click="emit('update:show', false)"
        >
          {{ $t(`Buttons.close`) }}
        </button>
      </div>
      <p v-if="isPowerCubeNotEnough" class="text-primary text-xs">
        {{ $t(`purchase.power.notEnough2`) }}
      </p>
    </div>

    <NSFWModalCrystalNotEnough
      v-model:show="showCrystalNotEnoughModal"
      :miss-amount="shouldByCrystalAmount"
    />
  </VanPopup>
</template>
<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { useCrystalUrl, usePowerUrl } from "@/use/common";
import { PropType, ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { sessionStorageSet } from "@/tools/sessionStorage";
import NSFWModalCrystalNotEnough from "@/views/NSFW/Modal/NSFWModalCrystalNotEnough.vue";
import { ApiPostCrystalTransactionBuyPower } from "@/apis/crystal";
import { showLoadingToast } from "vant";
import { useI18n } from "vue-i18n";
import { watch } from "vue";

const router = useRouter();
const route = useRoute();
const userStore = useGlobalUser();
const { t } = useI18n();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  reqData: {
    type: Object as PropType<PromptJson | MateTrait>,
    required: true,
  },
});

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  generate: () => undefined,
});

const showAmount = ref(true);
watch(
  () => props.show,
  (val) => {
    if (val) {
      if ([6, 9].includes(Number(route.query.mode))) {
        showAmount.value = false;
      } else {
        showAmount.value = true;
      }
    }
  }
);

const clickBuyMore = () => {
  sessionStorageSet("reqData", props.reqData);
  router.push(`/crystal#2`);
};

const isPowerCubeNotEnough = computed(
  () => (props.reqData.amount || 1) * 2 > userStore.user.powerAmount
);

const shouldByCrystalAmount = computed(() =>
  Math.ceil(((props.reqData.amount || 1) * 2 - userStore.user.powerAmount) / 20)
);

const showCrystalNotEnoughModal = ref(false);
const clickSwapAndGenerate = async () => {
  if (userStore.user.crystalQuantity < shouldByCrystalAmount.value)
    return (showCrystalNotEnoughModal.value = true);
  const loading = showLoadingToast(t("Message.swapping"));
  try {
    await ApiPostCrystalTransactionBuyPower(shouldByCrystalAmount.value);
    loading.close();
    emit("generate");
    emit("update:show", false);
  } catch (e) {
    loading.close();
  }
};
</script>
